import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Link } from 'react-router'
import { Typeahead } from 'react-bootstrap-typeahead'

import {
  BootstrapTable,
  defaultSortName,
  defaultSortOrder,
  TableHeaderColumn
} from 'react-bootstrap-table'

import {
  Button,
  Col,
  Form,
  FormControl,
  FormGroup,
  Modal,
  OverlayTrigger,
  Panel,
  Tooltip,
} from 'react-bootstrap'
import DatePicker from 'react-bootstrap-date-picker'
import Dropdown from './dropdown'
import Loadable from 'react-loading-overlay'

@observer(['activities', 'globals', 'tasks', 'users', 'companies', 'addresses'])
export default class TasksTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showEditModal: false,
      showMassDuedateModal: false,
      showMassAssignedUserModal: false,
      companyPhone: '',
      companyEmail: '',
      formattedDueDate: '',
      selectAllOverride: true,
      selectAll: false,
      selected: [],
      currPage: 1,
      prevPage: 1,
      loadableState: true,
      assignedUserId: 0,
      assignedUserName: '',
      newAssigned: 0,
      massAssignedUserId: 0,
      ogAssignedUserId: 0,
      companyId: 0
    }

    this.props.reload(() => {
      this.changeLoadableState()
    })

    this.onSelectAll = this.onSelectAll.bind(this)
    this.onRowSelect = this.onRowSelect.bind(this)

    this.props.tasks.loadtaskPriorities()
    this.props.users.loadAllOrganizationUsers(localStorage.getItem('userOrganizationId'))
  }

  changeLoadableState() {
    this.setState({
      loadableState: false
    })
  }

  selectAllOnPage(e) {
    const newSelectAllState = !this.state.selectAll
    this.setState({
      selectAllOverride: true,
      selectAll: newSelectAllState
    })

    const cb = document.getElementsByName('cbDuedate')

    for (let i=0; i<cb.length; i++) {
      eval('this.setState({cb_' + cb[i].value + ': newSelectAllState})')
    }
  }

// Mass Due Date Change Functions
  openMassDueDate() {
    const rows = this.state.selected
    let numRowsSelected = rows.length

    if (numRowsSelected < 1) {
      alert('Please select at least one row.')
    } else {
      let dd = new Date()
      let dateString = dd.getUTCFullYear() + '-' + ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2)
      this.setState({
        showMassDuedateModal: true,
        formattedMassDueDate: dateString
      })
    }
  }

  closeMassDuedate() {
    this.setState({
      showMassDuedateModal: false,
      formattedMassDueDate: ''
    })
  }

  saveMassDuedate(e) {
    this.setState({
      loadableState: true
    })

    const rows = this.state.selected
    const dueDate = this.state.formattedMassDueDate

    let promiseVariable = new Promise((resolve, reject) => {
      for( let i=0; i<rows.length; i++ ) {
        const params = {
          id: rows[i],
          dueDate: this.state.formattedMassDueDate
        }
  
        this.props.onMassDueDateSave(params, () => {
          if (i == (rows.length-1)) {
            resolve()
          }
        })
      }
    });
    
    promiseVariable.then((data) => {
      this.props.reload(() => {
        this.setState({
            loadableState: false,
            selected: []
        }, () => {
        })
      })
    }).catch((err) => {
        alert('Something happened!  Please try again.  If the problem persists contact MC3 Solutions.')
        this.setState({
            loadableState: false,
            selected: []
        }, () => {
        })
    })

    this.closeMassDuedate(e)
  }

  dueDateChanged(value, formattedValue) {
    this.setState({
      formattedDueDate: formattedValue
    })
  }

  massEditDueDateChanged(value, formattedValue) {
    this.setState({
      formattedMassDueDate: formattedValue
    })
  }

//Mass Assigned User Change Functions 
  openMassAssignedUser() {
    const rows = this.state.selected
    let numRowsSelected = rows.length

    if (numRowsSelected < 1) {
      alert('Please select at least one row.')
    } else {
      this.setState({
        showMassAssignedUserModal: true,
        formattedMassDueDate: 0
      })
    }
  }

  closeMassAssignedUser() {
    this.setState({
      showMassAssignedUserModal: false,
      formattedMassDueDate: ''
    })
  }

  saveMassAssignedUser(e) {
    this.setState({
      loadableState: true
    })

    const rows = this.state.selected

    let promiseVariable = new Promise((resolve, reject) => {
      for( let i=0; i<rows.length; i++ ) {
        const params = {
          id: rows[i],
          assignedUserId: this.state.massAssignedUserId,
          newAssigned: 1
        }

        this.props.onMassAssignedUserSave(params, () => {
          if (i == (rows.length-1)) {
            resolve()
          }
        })
      }
    });
    
    promiseVariable.then((data) => {
      this.props.reload(() => {
        this.setState({
            loadableState: false,
            selected: []
        }, () => {
        })
      })
    }).catch((err) => {
        alert('Something happened!  Please try again.  If the problem persists contact MC3 Solutions.')
        this.setState({
            loadableState: false,
            selected: []
        }, () => {
        })
    })

    this.closeMassAssignedUser(e)
  }

  onMassAssignedUserChanged(e) {
    if (e.length > 0) {
      this.setState({
        massAssignedUserId: e[0].id
      })
    } else {
      this.setState({
        massAssignedUserId: 0
      })
    }
  }

  formatCheckbox(cell, row) {
    let checkedText = ''

    if (this.state.selectAllOverride) {
      checkedText = this.state.selectAll ? 'checked' : ''
    } else if (eval('this.state.cb_' + cell + ' != undefined')) {
      checkedText = eval('this.state.cb_' + cell) ? 'checked' : ''
    }

    return (
      <div>
        <input type="checkbox" name="cbDuedate" value={ cell } checked={ checkedText } onChange={ this.checkboxChanged.bind(this) } />
      </div>
    )
  }

  sortByCreatedDate(a, b, order) {
    const aa = a.formattedCreatedDate.split('-')
    const bb = b.formattedCreatedDate.split('-')

    return this.sortByDate(aa, bb, order)
  }

  sortByDueDate(a, b, order) {
    const aa = a.formattedDueDate.split('-')
    const bb = b.formattedDueDate.split('-')

    return this.sortByDate(aa, bb, order)
  }

  sortByDate(aa, bb, order) {
    const fa = aa[2] + aa[0] + aa[1]
    const fb = bb[2] + bb[0] + bb[1]

    if (order == 'desc') {
      return fb - fa
    } else {
      return fa - fb
    }
  }

  formatCompanyLink(cell, row) {

    let formatCompanyLink = 'Loading...'

    if (cell) {
      if (row.companyId != null) {
        formatCompanyLink = (
          <Link to={ '/company/details/' + row.companyId }>{ cell }</Link>
        )
      } else {
        formatCompanyLink = (
          <Link to={ '/partner/' + row.partnerId }>{ cell }</Link>
        )
      }

    }

    return formatCompanyLink
  }

  formatActions(cell, row) {
    return (
      <div>
        <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'editTask-' + cell} >Edit Task</Tooltip> }><Button bsSize="small" bsStyle="warning" onClick={ (e) => { this.openEdit(e, cell) } }><i className="fa fa-pencil" aria-hidden="true"></i></Button></OverlayTrigger>
        <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'deleteTask-' + cell}>Delete Task</Tooltip> }><Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deleteTask(row, cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button></OverlayTrigger>
      </div>
    )
  }

  checkboxChanged(e) {
    this.setState({
      selectAllOverride: false
    })

    if (eval('this.state.cb_' + e.target.value + ' != undefined')) {
      eval('this.setState({ cb_' + e.target.value + ': !this.state.cb_' + e.target.value + ' })')
    } else {
      eval('this.setState({ cb_' + e.target.value + ': e.target.checked })')
    }
  }

  onAssignedUserChanged(e) {
    if (e.length > 0) {
      if (this.state.ogAssignedUserId != e[0].id) {
        this.setState({
          newAssigned: 1
        })
      } else {
        this.setState({
          newAssigned: 0
        })
      }
    } else {
        this.setState({
          newAssigned: 0
        })
    }

    if (e.length > 0) {
      this.setState({
        assignedUserId: e[0].id,
        assignedUserName: e[0].name
      })
    } else {
      this.setState({
        assignedUserId: 0,
        assignedUserName: ''
      })
    }
  }

  openEdit(e, id) {
    this.setState({
      showEditModal: true
    })

    this.props.onLoadTask(id, (data) => {
      this.setState({
        companyId: data.companyId,
        taskId: id,
        taskPriorityId: data.taskPriorityId,
        taskStateId: data.taskStateId,
        task: data.task,
        companyPhone: data.companyPhone,
        companyEmail: data.companyEmail,
        assignedUserId: data.assignedUserId,
        ogAssignedUserId: data.assignedUserId,
        assignedUserName: data.assignedUserName,
        formattedDueDate: data.formattedDueDate
      })
    })
  }

  closeEdit() {
    this.setState({
      showEditModal: false,
      companyPhone: '',
      companyEmail: '',
      formattedDueDate: '',
      assignedUserId: 0,
      assignedUserName: '',
      newAssigned: 0,
      ogAssignedUserId: 0,
      companyId: 0
    })
  }

  saveTask(e) {
    this.setState({
      loadableState: true
    })

    const params = {
      id: this.state.taskId,
      assignedUserId: this.state.assignedUserId,
      newAssigned: this.state.newAssigned,
      taskPriorityId: this.state.taskPriorityId,
      taskStateId: this.state.taskStateId,
      dueDate: this.state.formattedDueDate,
      task: this.state.task
    }

    let promiseVariable = new Promise((resolve, reject) => {
      this.props.onSaveTask(params, (data) => {
        resolve()
      })
    });

    promiseVariable.then((data) => {
      this.props.reload(() => {
        this.setState({
            loadableState: false,
        })
      })
    }).catch((err) => {
      alert(err)
      this.setState({
          loadableState: false
      })
    })

    //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
    this.props.activities.logNewActivity(localStorage.getItem('userId'), 'update', 2, this.state.taskId, 1, this.state.companyId)

    this.closeEdit()
  }

  deleteTask(row, id) {
    if (confirm("Are you sure you want to delete this task?")) {
      this.props.onDeleteTask(id)
      //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
      this.props.activities.logNewActivity(localStorage.getItem('userId'), 'delete', 2, id, 1, row.companyId)
    }
  }

  onRowSelect({ id }, isSelected) {
    if (isSelected) {
      const currPage = this.refs.table.state.currPage

      if (currPage != this.state.prevPage) {
        this.setState({
          selected: [],
          prevPage: currPage
        })
      }

      this.setState({
        selected: [ ...this.state.selected, id ].sort(),
        currPage: this.refs.table.state.currPage
      });
    } else {
      this.setState({ selected: this.state.selected.filter(it => it !== id) });
    }

    return false;
  }

  onSelectAll(isSelected) {
    let rows = []

    if (isSelected) {
      rows = this.refs.table.state.data.map(row => row.id)
    }

    this.setState({
      selected: rows
    })

    return rows
  }

  onTaskChange(e) {
    this.setState({
      task: e.target.value
    })
  }

  onTaskPriorityChanged(e) {
    this.setState({
      taskPriorityId: e.target.value
    })
  }

  onTaskStateChanged(e) {
    this.setState({
      taskStateId: e.target.value
    })
  }

  render() {
    const selectAllText = this.state.selectAll ? 'Unselect' : 'Select'
    const options = {
      defaultSortName: 'formattedDueDate',  // default sort column name
      defaultSortOrder: 'asc'  // default sort order
    }
    const taskPrioritiesOptions = this.props.tasks.data.map((priority) => {
      return priority.name
    })
    
    const selectRowProp = {
      mode: 'checkbox',
      onSelect: this.onRowSelect,
      onSelectAll: this.onSelectAll,
      selected: this.state.selected,
      columnWidth: '15px'
    }

    let location = ''

    if (this.props.hideLocation && this.props.hideLocation == true) {
      location = <TableHeaderColumn hidden width="100" dataField="id" dataSort={ true } editable={ false }>Location</TableHeaderColumn>
    } else {
      location = <TableHeaderColumn width="100" dataField="location" dataSort={ true } editable={ false } filter={ { type: 'TextFilter', delay: 50 } }>Location</TableHeaderColumn>
    }

    let vendor = ''

    if (this.props.hideVendor && this.props.hideVendor == true) {
      vendor = <TableHeaderColumn hidden width="100" dataField="id" dataSort={ true } editable={ false }>Vendor</TableHeaderColumn>
    } else {
      vendor = <TableHeaderColumn width="50" dataField="vendorName" dataSort={ true } editable={ false } filter={ { type: 'TextFilter', delay: 50 } }>Vendor</TableHeaderColumn>
    }


    return (
      <div>
        <Loadable active={ this.state.loadableState } spinner text='Processing your request...'>
          <Button bsStyle="warning" onClick={ this.openMassDueDate.bind(this) }>Update Due Dates</Button>
          <Button bsStyle="warning" onClick={ this.openMassAssignedUser.bind(this) }>Update Assigned Users</Button>
          <BootstrapTable
            data={ this.props.data }
            striped={ true }
            hover={ true }
            pagination={ true }
            search={ true }
            options={ options }
            bordered={ true }
            selectRow={ selectRowProp }
            ref="table"
          >
            <TableHeaderColumn width="50" dataField="id" hidden isKey={ true } dataSort={ true } dataAlign="center" hiddenOnInsert={ true } autoValue={ true }>ID</TableHeaderColumn>
            <TableHeaderColumn width="25" dataField="id" hidden dataAlign="center" hiddenOnInsert={ true } dataFormat={ this.formatCheckbox.bind(this) } autoValue={ true }></TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="formattedCreatedDate" sortFunc={ this.sortByCreatedDate.bind(this) } dataSort={ true } editable={ false } filter={ { type: 'TextFilter', delay: 50 } }>Created</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="formattedDueDate" sortFunc={ this.sortByDueDate.bind(this) } dataSort={ true } editable={ false } filter={ { type: 'TextFilter', delay: 50 } }>Due</TableHeaderColumn>
            <TableHeaderColumn width="100" dataField={ this.props.taskType } dataSort={ true } dataFormat={ this.formatCompanyLink.bind(this) } filter={ { type: 'TextFilter', delay: 50 } }>{ this.props.taskTypeHeading }</TableHeaderColumn>
            <TableHeaderColumn width="75" dataField="userName" dataSort={ true } editable={ false } filter={ { type: 'TextFilter', delay: 50 } }>Created By</TableHeaderColumn>
            <TableHeaderColumn width="75" dataField="assignedUserName" dataSort={ true } editable={ false } filter={ { type: 'TextFilter', delay: 50 } }>Assigned To</TableHeaderColumn>
            { vendor }
            { location }
            <TableHeaderColumn width="50" dataField="taskPriorityName" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Priority</TableHeaderColumn>
            { /* source */ }
            <TableHeaderColumn width="150" dataField="task" dataSort={ true } editable={ false} filter={ { type: 'TextFilter', delay: 50 } }>Task</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
          </BootstrapTable>
          <Modal show={ this.state.showEditModal } onHide={ this.closeEdit.bind(this) }>
            <Modal.Header closeButton>
              <Modal.Title>Edit Task</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form horizontal name="newTaskForm">
                <Panel header={ <h3>Contact Information</h3> }>
                  <Col sm={ 4 }>Phone: { this.state.companyPhone }</Col>
                  <Col sm={ 6 }>Email: { this.state.companyEmail }</Col>
                </Panel>
                <Panel header={ <h3>Task Information</h3> }>
                  <FormGroup>
                    <input type="hidden" id="editTaskId" />
                    <Col><Typeahead clearButton labelKey="name" options={ this.props.users.all } onChange={ this.onAssignedUserChanged.bind(this) } selected={ [{ id: this.state.assignedUserId, name: this.state.assignedUserName }] } placeholder="Choose a user..." /></Col>
                  </FormGroup>
                  <FormGroup>
                    <Col sm={ 4 }><Dropdown data={ this.props.tasks.data } id="editTaskPriorityId" defaultValue={ this.state.taskPriorityId } onChange={ this.onTaskPriorityChanged.bind(this) } /></Col>
                    <Col sm={ 4 }><Dropdown data={ this.props.tasks.taskStates } id="editTaskStateId" defaultValue={ this.state.taskStateId } onChange={ this.onTaskStateChanged.bind(this) } /></Col>
                    <Col sm={ 4 }><DatePicker id="editDueDate" dateFormat="YYYY-MM-DD" value={this.state.formattedDueDate} onChange={ this.dueDateChanged.bind(this) } /></Col>
                  </FormGroup>
                    <FormGroup>
                      <Col sm={ 12 }><FormControl componentClass="textarea" placeholder="Task" id="editTask" value={ this.state.task } onChange={ this.onTaskChange.bind(this) } /></Col>
                    </FormGroup>
                  </Panel>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button bsStyle="danger" onClick={ this.closeEdit.bind(this) }><i className="fa fa-ban" aria-hidden="true"></i> Cancel</Button>
              <Button bsStyle="success" onClick={ this.saveTask.bind(this) }><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
            </Modal.Footer>
          </Modal>
          <Modal show={ this.state.showMassDuedateModal } onHide={ this.closeMassDuedate.bind(this) } bsSize="sm">
            <Modal.Header closeButton>
              <Modal.Title>Update Due Date</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form horizontal name="massDuedateForm">
                <FormGroup>
                  <Col sm={ 12 }><DatePicker id="massEditDueDate" dateFormat="YYYY-MM-DD" value={this.state.formattedMassDueDate} onChange={ this.massEditDueDateChanged.bind(this) } /></Col>
                </FormGroup>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button bsStyle="danger" onClick={ this.closeMassDuedate.bind(this) }><i className="fa fa-ban" aria-hidden="true"></i> Cancel</Button>
              <Button bsStyle="success" onClick={ this.saveMassDuedate.bind(this) }><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
            </Modal.Footer>
          </Modal>
          <Modal show={ this.state.showMassAssignedUserModal } onHide={ this.closeMassAssignedUser.bind(this) } bsSize="sm">
            <Modal.Header closeButton>
              <Modal.Title>Update Assigned User</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form horizontal name="massAssignUserForm">
                <FormGroup>
                  <Col sm={ 12 }><Typeahead clearButton labelKey="name" options={ this.props.users.all } onChange={ this.onMassAssignedUserChanged.bind(this) } placeholder="Choose a user..." /></Col>
                </FormGroup>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button bsStyle="danger" onClick={ this.closeMassAssignedUser.bind(this) }><i className="fa fa-ban" aria-hidden="true"></i> Cancel</Button>
              <Button bsStyle="success" onClick={ this.saveMassAssignedUser.bind(this) }><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
            </Modal.Footer>
          </Modal>
        </Loadable>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/taskstable.js